/* Hayati Essence: drawers, search, basket, size buttons, quantity, sticky buy bar, tabs, family filter. */
(function () {
  'use strict';
  var d = document;
  var T = window.heTheme || { strings: {} };

  function money(cents) {
    var a = (cents / 100).toFixed(2);
    return (T.moneyFormat || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key.indexOf('no_decimals') > -1) { return String(Math.round(cents / 100)); }
      if (key.indexOf('comma') > -1) { return a.replace('.', ','); }
      return a;
    });
  }
  function esc(s) { var e = d.createElement('div'); e.textContent = s; return e.innerHTML; }

  /* ---------- Drawers ---------- */
  var scrim = d.querySelector('.he-scrim');
  var current = null;
  var lastFocus = null;
  function getDrawer(name) { return d.getElementById(name === 'nav' ? 'he-nav-drawer' : 'he-basket-drawer'); }
  function openDrawer(name) {
    var el = getDrawer(name);
    if (!el) { return false; }
    if (current) { closeDrawer(true); }
    lastFocus = d.activeElement;
    el.classList.add('is-open');
    if (scrim) { scrim.hidden = false; }
    d.documentElement.style.overflow = 'hidden';
    current = el;
    var c = el.querySelector('[data-he-close]');
    if (c) { c.focus(); }
    return true;
  }
  function closeDrawer(silent) {
    if (!current) { return; }
    current.classList.remove('is-open');
    if (scrim) { scrim.hidden = true; }
    d.documentElement.style.overflow = '';
    current = null;
    if (!silent && lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  /* ---------- Basket ---------- */
  function refreshCart() {
    return fetch((T.root || '/') + '?sections=he-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['he-cart-drawer'];
        if (!html) { return; }
        var t = d.createElement('div');
        t.innerHTML = html;
        var fresh = t.querySelector('#he-basket-drawer');
        var old = d.getElementById('he-basket-drawer');
        if (!fresh || !old) { return; }
        old.innerHTML = fresh.innerHTML;
        var n = fresh.getAttribute('data-count') || '0';
        d.querySelectorAll('.he-count').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); });
      });
  }

  /* ---------- Search ---------- */
  var search = d.getElementById('he-search');
  var searchInput = d.getElementById('he-search-input');
  var results = d.querySelector('[data-he-results]');
  var timer;
  function toggleSearch() {
    if (!search) { return; }
    search.hidden = !search.hidden;
    if (!search.hidden && searchInput) { searchInput.focus(); }
  }
  if (searchInput && results && T.predictive) {
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(T.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var list = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!list.length) { results.innerHTML = '<p class="he-results__none">' + esc(T.strings.noResult || '') + '</p>'; return; }
            results.innerHTML = list.map(function (p) {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              var price = parseFloat(p.price_min || p.price);
              return '<a href="' + p.url + '">' +
                (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56">' : '<span></span>') +
                '<strong>' + esc(p.title) + '</strong><span>' + (isNaN(price) ? '' : money(Math.round(price * 100))) + '</span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- Clicks handled in one place ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-he-open]');
    if (opener) { if (openDrawer(opener.getAttribute('data-he-open'))) { e.preventDefault(); } return; }
    if (t.closest('[data-he-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-he-search]')) { toggleSearch(); return; }
    var sub = t.closest('.he-sub-toggle');
    if (sub) {
      var li = sub.parentNode;
      var open = li.classList.toggle('is-open');
      sub.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var rm = t.closest('[data-he-remove]');
    if (rm) {
      e.preventDefault();
      fetch((T.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-he-remove'), quantity: 0 }) })
        .then(refreshCart)
        .catch(function () { window.location.href = rm.href; });
      return;
    }
    var miniQty = t.closest('[data-he-cart-qty]');
    if (miniQty) {
      e.preventDefault();
      var key = miniQty.getAttribute('data-he-cart-qty');
      var qty = Math.max(0, Number(miniQty.getAttribute('data-quantity')) + Number(miniQty.getAttribute('data-change')));
      miniQty.disabled = true;
      fetch((T.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { if (!r.ok) { throw new Error('Cart change failed'); } return refreshCart(); })
        .catch(function () { window.location.href = T.cartPage || '/cart'; });
      return;
    }
    var step = t.closest('[data-he-step]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      if (!input) { return; }
      var min = parseInt(input.min, 10); if (isNaN(min)) { min = 1; }
      var next = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-he-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var thumb = t.closest('[data-he-thumb]');
    if (thumb) {
      var main = d.getElementById('he-main-img');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.getAttribute('data-src'); }
      thumb.parentNode.querySelectorAll('[data-he-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    if (current) { closeDrawer(); } else if (search && !search.hidden) { search.hidden = true; }
  });


  /* ---------- Homepage product filters (only hide what Shopify rendered) ---------- */
  d.querySelectorAll('[data-he-filters]').forEach(function (filters) {
    var id = filters.getAttribute('data-he-filters');
    var grid = d.querySelector('[data-he-featured-grid="' + id + '"]');
    if (!grid) { return; }
    filters.querySelectorAll('[data-he-show]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wanted = b.getAttribute('data-he-show');
        filters.querySelectorAll('[data-he-show]').forEach(function (btn) { btn.setAttribute('aria-pressed', btn === b ? 'true' : 'false'); });
        var count = 0;
        grid.querySelectorAll('.he-card').forEach(function (card) {
          var match = wanted === 'all' || card.getAttribute('data-he-category') === wanted;
          card.hidden = !match;
          if (match) { count++; }
        });
        var message = grid.nextElementSibling;
        if (message && message.classList.contains('he-featured-empty')) { message.hidden = count !== 0; }
      });
    });
  });

  /* ---------- Card quick-add: Shopify AJAX cart with normal POST fallback ---------- */
  d.querySelectorAll('form[data-he-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = form.querySelector('button[type="submit"]');
      if (b) { b.disabled = true; }
      fetch((T.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) { if (!r.ok) { throw new Error('Basket add failed'); } return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { if (b) { b.disabled = false; } openDrawer('basket'); })
        .catch(function () { form.submit(); });
    });
  });

  /* ---------- Product page ---------- */
  var root = d.querySelector('[data-he-product]');
  if (root) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-he-variants]').textContent); } catch (err) { variants = []; }
    var form = root.querySelector('form[data-he-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = root.querySelector('[data-he-price]');
    var addBtn = form ? form.querySelector('[data-he-add]') : null;
    var nowBtn = form ? form.querySelector('.he-buynow') : null;
    var errorEl = form ? form.querySelector('.he-form-error') : null;
    var sticky = d.querySelector('[data-he-sticky]');
    var stickyPrice = d.querySelector('[data-he-sticky-price]');
    var stickyBtn = d.querySelector('[data-he-sticky-btn]');

    var setVariant = function (id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v || !idInput) { return; }
      idInput.value = v.id;
      root.querySelectorAll('.he-pill').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-id') === String(v.id) ? 'true' : 'false'); });
      var html = '<ins>' + money(v.price) + '</ins>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<del>' + money(v.compare_at_price) + '</del><span class="he-save">' + (T.strings.save || 'Save') + ' ' + money(v.compare_at_price - v.price) + '</span>';
      }
      if (priceEl) { priceEl.innerHTML = html; }
      if (stickyPrice) { stickyPrice.innerHTML = money(v.price); }
      var newImg = v.featured_image && (v.featured_image.src || v.featured_image.url);
      if (newImg) { var gallery = d.getElementById('he-main-img'); if (gallery) { gallery.removeAttribute('srcset'); gallery.src = newImg; } }
      [addBtn, stickyBtn].forEach(function (b) { if (b) { b.disabled = !v.available; b.textContent = v.available ? T.strings.add : T.strings.soldOut; } });
      if (nowBtn) { nowBtn.hidden = !v.available; }
      if (errorEl) { errorEl.hidden = true; }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u); } catch (err2) {}
    };
    root.querySelectorAll('.he-pill').forEach(function (b) {
      b.addEventListener('click', function () { setVariant(b.getAttribute('data-id')); });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var buyNow = e.submitter && e.submitter.classList.contains('he-buynow');
        var btn = e.submitter || addBtn;
        if (btn) { btn.disabled = true; }
        fetch((T.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (btn) { btn.disabled = false; }
            if (!res.ok) {
              if (errorEl) { errorEl.textContent = res.body.description || res.body.message || 'That could not be added. Please try again.'; errorEl.hidden = false; }
              return;
            }
            if (buyNow) { window.location.href = (T.root || '/') + 'checkout'; return; }
            return refreshCart().then(function () { openDrawer('basket'); });
          })
          .catch(function () { form.submit(); });
      });
    }

    /* Buy bar on phones: shown whenever the main button is off screen. */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      if (stickyBtn) { stickyBtn.addEventListener('click', function () { if (!addBtn.disabled) { addBtn.click(); } }); }
    }
  }

  /* ---------- Tabs on desktop, accordion on phones ---------- */
  d.querySelectorAll('[data-he-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[role="tab"]');
    var panels = wrap.querySelectorAll('.he-tabs__panel');
    function select(i) {
      tabs.forEach(function (tab, n) { tab.setAttribute('aria-selected', n === i ? 'true' : 'false'); tab.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) { p.classList.toggle('is-current', n === i); });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
        var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        select(n);
        tabs[n].focus();
      });
    });
    panels.forEach(function (p) {
      var b = p.querySelector('.he-tabs__acc button');
      if (!b) { return; }
      b.addEventListener('click', function () {
        var open = p.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });

  /* ---------- Native Shopify collection filters on small screens ---------- */
  var filterPanel = d.getElementById('he-filter-panel');
  var filterOpener = d.querySelector('[data-he-filter-open]');
  var filterClose = d.querySelector('[data-he-filter-close]');
  if (filterPanel && filterOpener) {
    function toggleFilter(on) {
      filterPanel.classList.toggle('is-open', !!on);
      filterOpener.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (window.matchMedia('(max-width: 879px)').matches) { d.body.classList.toggle('he-filters-open', !!on); }
      if (on && filterClose) { filterClose.focus(); }
      if (!on) { filterOpener.focus(); }
    }
    filterOpener.addEventListener('click', function () { toggleFilter(true); });
    d.querySelectorAll('[data-he-filter-close]').forEach(function (b) { b.addEventListener('click', function () { toggleFilter(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && filterPanel.classList.contains('is-open')) { toggleFilter(false); } });
  }

  /* ---------- Collection: fragrance family filter and sorting ---------- */
  var fam = d.querySelector('[data-he-families]');
  if (fam) {
    var cards = d.querySelectorAll('[data-he-grid] .he-card');
    var count = d.querySelector('[data-he-count]');
    var apply = function (f) {
      fam.querySelectorAll('[data-he-family]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-he-family') === f ? 'true' : 'false'); });
      var n = 0;
      cards.forEach(function (c) { var show = !f || c.getAttribute('data-family') === f; c.hidden = !show; if (show) { n++; } });
      if (count) { count.textContent = n + (n === 1 ? ' product' : ' products'); }
    };
    fam.addEventListener('click', function (e) {
      var b = e.target.closest('[data-he-family]');
      if (!b) { return; }
      var f = b.getAttribute('data-he-family');
      apply(f);
      try { var u = new URL(window.location.href); if (f) { u.searchParams.set('family', f); } else { u.searchParams.delete('family'); } window.history.replaceState(null, '', u); } catch (err) {}
    });
    try { var first = new URL(window.location.href).searchParams.get('family'); if (first) { apply(first); } } catch (err3) {}
  }
  var sort = d.querySelector('[data-he-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  /* ---------- Basket page: changing a quantity updates the basket ---------- */
  var cartForm = d.querySelector('[data-he-cartform]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) { if (e.target.matches('input[name="updates[]"]')) { cartForm.submit(); } });
  }
})();
